export default [{
  name: 'serviceGroupList',
  method: 'get',
  desc: '获取国内机场',
  path: 'https://qgesl-mdk.oss-cn-beijing.aliyuncs.com/optapp/serviceData.json',
  serveType: 'btlh',
  params: {}
},
]
